<template>
  <div ref="line-container" class="line-container">
    <div
      v-for="(item, indexItem) in itemsData"
      :key="'item-' + indexItem"
      :style="{ marginTop: marginTop + 'px', marginBottom: marginBottom + 'px' }"
    >
      <div :ref="'container-item-' + item.id" class="sub-item">
        <nuxt-link :to="item.url">
          <img
            :ref="'item-' + item.id"
            class="image"
            :src="item.cover"
            :alt="item.name"
            width="500"
            height="500"
            @load="itemLoaded(item.id)"
          />
          <div class="overlay">
            <h4 class="name">{{ item.name }}</h4>
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    marginLeft: {
      type: Number,
      required: false,
      default: 5
    },
    marginRight: {
      type: Number,
      required: false,
      default: 5
    },
    marginTop: {
      type: Number,
      required: false,
      default: 5
    },
    marginBottom: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data() {
    return {
      forcedHeight: 350,
      itemsData: [],
      itemsLoaded: []
    };
  },
  watch: {
    itemsLoaded() {
      if (this.allItemsLoaded) this.buildLine();
    }
  },
  mounted() {
    window.addEventListener('resize', this.itemLoaded);
    this.itemsData = this.items;
  },
  methods: {
    allItemsLoaded() {
      return this.itemsData.every((el) => this.itemsLoaded.some((itemId) => el.id == itemId));
    },
    buildLine() {
      let containerWidth = this.$refs['line-container'].clientWidth;
      const totalItems = this.itemsData.length;
      containerWidth = containerWidth - (totalItems - 1) * 10;
      let actualLineWidth = totalItems * (this.marginLeft + this.marginRight);

      this.itemsData.forEach((item) => {
        const actualItem = this.$refs['item-' + item.id][0];
        let actualItemWidth = actualItem.clientWidth;
        actualItemWidth = Math.floor(
          (actualItemWidth * this.forcedHeight) / actualItem.clientHeight
        );
        item.height = this.forcedHeight;
        item.width = actualItemWidth;
        actualLineWidth += actualItemWidth;
      });

      this.itemsData.forEach((item, i) => {
        const containerItem = this.$refs['container-item-' + item.id][0];
        const actualItem = this.$refs['item-' + item.id][0];
        const finalHeight = Math.floor((containerWidth * this.forcedHeight) / actualLineWidth);
        const finalWidth = Math.floor((finalHeight * item.width) / item.height);

        containerItem.style.marginLeft = !(i === 0)
          ? Math.floor((finalHeight * this.marginLeft) / item.height) + 'px'
          : 0 + 'px';
        containerItem.style.marginRight = !(i === totalItems - 1)
          ? Math.floor((finalHeight * this.marginRight) / item.height) + 'px'
          : 0 + 'px';

        containerItem.style.height = finalHeight + 'px';
        containerItem.style.width = finalWidth + 'px';
        actualItem.style.height = finalHeight + 'px';
        actualItem.style.width = finalWidth + 'px';
        item.height = finalHeight;
        item.width = finalWidth;
      });
    },
    itemLoaded(itemId) {
      this.itemsLoaded.push(itemId);
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  margin-bottom: 160px;
}

.line-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.item {
  position: relative;
  height: 520px;
  width: 100%;
  margin-bottom: 20px;
}

.sub-item {
  position: relative;
  border-radius: 6px;
  @include md {
    height: 75px;
  }
}

.name {
  position: absolute;
  background-color: #00000045;
  text-shadow: 0px 3px 15px #000000b5;
  width: 100%;
  height: 100%;
  text-align: center;
  letter-spacing: 0.15px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding: 15px;
  font-size: 16px;
  transition: 0.4s;
  @include md {
    font-size: 12px;
  }
}

.name:hover {
  cursor: pointer;
  background-color: #00000015;
  transition: 0.4s;
}

.image {
  display: block;
  border-radius: 6px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
